export default __webpack_public_path__ + "static/outlookIcon-c18573040d19c2e3d41bb02881ca528b.svg";